import { Box } from '@material-ui/core';
import { formatPercent, PayoutSummary } from '@nemuru-eng/js-api-client';

import { PayoutSummaryConditionsRow } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryConditionsTable/components/PayoutSummaryConditionsRow';
import { usePayoutSummary } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryConditionsTable/hooks/usePayoutSummary';
import { CustomDivider } from '@/components/shared/components/CustomDivider';

interface PayoutSummaryConditionsBodyProps {
  payoutSummary: PayoutSummary;
}

export const PayoutSummaryConditionsBody = ({ payoutSummary }: PayoutSummaryConditionsBodyProps) => {
  const { sales, refunds, fixedFees, variableFees, vatOnFees, currency, adjustments, vatOnAdjustments, total } =
    usePayoutSummary({
      payoutSummary,
    });

  return (
    <Box flexDirection="column">
      <PayoutSummaryConditionsRow labelTid={'SALES'} quantity={sales.quantity} amount={sales.amount} />
      <PayoutSummaryConditionsRow labelTid={'REFUNDS'} quantity={refunds.quantity} amount={refunds.amount} />
      <PayoutSummaryConditionsRow
        labelTid={'SUBTOTAL'}
        amount={{ value: sales.amount.value + refunds.amount.value, currency }}
        strongLabel
      />
      <CustomDivider my={2} />
      <PayoutSummaryConditionsRow labelTid={'FIXED_FEES'} quantity={fixedFees.quantity} amount={fixedFees.amount} />
      <PayoutSummaryConditionsRow
        labelTid={'VARIABLE_FEES'}
        quantity={variableFees.quantity}
        amount={variableFees.amount}
      />
      <PayoutSummaryConditionsRow
        labelTid={'VAT_ON_FEES'}
        labelDynamicDataTexts={[formatPercent(vatOnFees.rate)]}
        amount={vatOnFees.amount}
      />
      <PayoutSummaryConditionsRow
        labelTid={'TOTAL_FEES'}
        strongLabel
        amount={{
          value: fixedFees.amount.value + variableFees.amount.value + vatOnFees.amount.value,
          currency,
        }}
      />
      <CustomDivider my={2} />
      <PayoutSummaryConditionsRow labelTid={'ADJUSTMENTS'} amount={adjustments.amount} />
      <PayoutSummaryConditionsRow
        labelTid={'VAT_ON_ADJUSTMENTS'}
        labelDynamicDataTexts={[formatPercent(vatOnAdjustments.rate)]}
        amount={vatOnAdjustments.amount}
      />
      <PayoutSummaryConditionsRow
        labelTid={'TOTAL_ADJUSTMENTS'}
        strongLabel
        amount={{
          value: adjustments.amount.value + vatOnAdjustments.amount.value,
          currency,
        }}
      />
      <CustomDivider my={2} />
      <PayoutSummaryConditionsRow labelTid={'TOTAL'} strongLabel strongValue amount={total.amount} />
    </Box>
  );
};
